import Api from "../../utils/axios";

export const ParcelCategoryApi = {
  createParcelCategory: (payload) =>
    Api.post("/master/create-parcel-category", payload),

  updateParcelCategory: (id, payload) =>
    Api.put(`/master/update-parcel-category/${id}`, payload),

  getSingleParcelCategory: (id) =>
    Api.get(`/master/get-single-parcel-category/${id}`),

  getAllParcelCategories: () =>
    Api.get(`/master/get-all-parcel-categories`),

  getAllParcelCategoriesWithPagination: (payload, search = "") =>
    Api.post(`/master/get-all-parcel-categories-pagination?search=${search}`, payload),

  deleteParcelCategory: (id) =>
    Api.delete(`/master/delete-parcel-category/${id}`),
};
